module.exports = __webpack_public_path__ + "static/img/AB4338766.70222df9.jpg";